var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	2950: () => (loadSingletonVersionCheckFallback("default", "react", [1,17,0,2], () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(2791))))))),
	9883: () => (loadSingletonVersionCheckFallback("default", "react", [0,"^18",0,0], () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(2791))))))),
	19: () => (loadStrictVersionCheckFallback("default", "styled-components", [0,"^5",3,5], () => (Promise.all([__webpack_require__.e(444), __webpack_require__.e(113)]).then(() => (() => (__webpack_require__(6444))))))),
	5686: () => (loadSingletonVersionCheckFallback("default", "react", [0,18,1,0], () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(2791))))))),
	7796: () => (loadSingletonVersionCheckFallback("default", "@descomplica/microfrontend-core", [0,1,2,0], () => (() => (__webpack_require__(5208))))),
	8698: () => (loadSingletonVersionCheckFallback("default", "react-dom", [0,18,1,0], () => (Promise.all([__webpack_require__.e(164), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(4164))))))),
	9705: () => (loadStrictVersionCheckFallback("default", "mobx-react", [0,7,3,0], () => (Promise.all([__webpack_require__.e(672), __webpack_require__.e(111), __webpack_require__.e(556)]).then(() => (() => (__webpack_require__(1672))))))),
	5544: () => (loadStrictVersionCheckFallback("default", "mobx", [1,6,1,0], () => (__webpack_require__.e(98).then(() => (() => (__webpack_require__(4098))))))),
	1371: () => (loadSingletonVersionCheckFallback("default", "react", [,[1,18],[1,17],[1,16,8,0],1,1], () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(2791))))))),
	4556: () => (loadSingletonFallback("default", "react-dom", () => (Promise.all([__webpack_require__.e(164), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(4164))))))),
	2232: () => (loadSingletonVersionCheckFallback("default", "react", [0,16,8,3], () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(2791))))))),
	3595: () => (loadStrictVersionCheckFallback("default", "styled-components", [0,4], () => (Promise.all([__webpack_require__.e(444), __webpack_require__.e(113)]).then(() => (() => (__webpack_require__(6444))))))),
	8416: () => (loadSingletonVersionCheckFallback("default", "react", [1,18,2,0], () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(2791))))))),
	915: () => (loadSingletonVersionCheckFallback("default", "react", [,[1,18,0],[1,17,0],[1,16,3],1,1], () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(2791))))))),
	6116: () => (loadSingletonVersionCheckFallback("default", "react", [0,16,8], () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(2791))))))),
	756: () => (loadSingletonVersionCheckFallback("default", "react", [1,18,0,0], () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(2791))))))),
	1649: () => (loadSingletonVersionCheckFallback("default", "react", [,[1,18,0,0],[1,17,0,0],[1,16,0,0],[1,15,0,0],[2,0,14,0],1,1,1,1], () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(2791))))))),
	7827: () => (loadSingletonVersionCheckFallback("default", "react", [0,16], () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(2791))))))),
	2113: () => (loadSingletonVersionCheckFallback("default", "react", [0,16,8,0], () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(2791))))))),
	117: () => (loadStrictVersionCheckFallback("default", "exceljs", [1,4,3,0], () => (__webpack_require__.e(415).then(() => (() => (__webpack_require__(5415))))))),
	128: () => (loadStrictVersionCheckFallback("default", "react-toastify", [1,9,1,3], () => (Promise.all([__webpack_require__.e(655), __webpack_require__.e(827)]).then(() => (() => (__webpack_require__(9655))))))),
	150: () => (loadStrictVersionCheckFallback("default", "mobx", [1,6,6,1], () => (__webpack_require__.e(98).then(() => (() => (__webpack_require__(4098))))))),
	172: () => (loadStrictVersionCheckFallback("default", "mobx-react", [1,7,4,0], () => (Promise.all([__webpack_require__.e(672), __webpack_require__.e(111)]).then(() => (() => (__webpack_require__(1672))))))),
	1667: () => (loadStrictVersionCheckFallback("default", "xlsx", [2,0,18,5], () => (__webpack_require__.e(45).then(() => (() => (__webpack_require__(4045))))))),
	1919: () => (loadStrictVersionCheckFallback("default", "@descomplica/foundation-ui-components", [4,0,0,89], () => (Promise.all([__webpack_require__.e(562), __webpack_require__.e(775)]).then(() => (() => (__webpack_require__(1562))))))),
	1936: () => (loadStrictVersionCheckFallback("default", "react-tabs", [1,6,0,2], () => (Promise.all([__webpack_require__.e(149), __webpack_require__.e(756)]).then(() => (() => (__webpack_require__(3149))))))),
	2488: () => (loadStrictVersionCheckFallback("default", "react-text-mask", [1,5,5,0], () => (Promise.all([__webpack_require__.e(587), __webpack_require__.e(649)]).then(() => (() => (__webpack_require__(3587))))))),
	3390: () => (loadStrictVersionCheckFallback("default", "class-validator", [2,0,14,0], () => (__webpack_require__.e(730).then(() => (() => (__webpack_require__(8730))))))),
	3544: () => (loadStrictVersionCheckFallback("default", "@descomplica/caching-browser", [1,1,0,5], () => (() => (__webpack_require__(2962))))),
	3839: () => (loadStrictVersionCheckFallback("default", "styled-components", [1,5,3,3], () => (Promise.all([__webpack_require__.e(444), __webpack_require__.e(113)]).then(() => (() => (__webpack_require__(6444))))))),
	3854: () => (loadStrictVersionCheckFallback("default", "react-google-recaptcha-v3", [1,1,10,1], () => (__webpack_require__.e(686).then(() => (() => (__webpack_require__(2686))))))),
	4479: () => (loadStrictVersionCheckFallback("default", "tsyringe", [1,4,7,0], () => (() => (__webpack_require__(2389))))),
	5243: () => (loadStrictVersionCheckFallback("default", "file-saver", [1,2,0,5], () => (__webpack_require__.e(802).then(() => (() => (__webpack_require__(4802))))))),
	5814: () => (loadStrictVersionCheckFallback("default", "react-router-dom", [1,6,0,2], () => (Promise.all([__webpack_require__.e(276), __webpack_require__.e(116)]).then(() => (() => (__webpack_require__(6276))))))),
	6129: () => (loadStrictVersionCheckFallback("default", "@descomplica/microfrontend-react", [1,1,1,2], () => (__webpack_require__.e(716).then(() => (() => (__webpack_require__(4716))))))),
	6218: () => (loadStrictVersionCheckFallback("default", "reflect-metadata", [2,0,1,13], () => (__webpack_require__.e(121).then(() => (() => (__webpack_require__(6121))))))),
	6759: () => (loadSingletonVersionCheckFallback("default", "react", [1,18,1,0], () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(2791))))))),
	6804: () => (loadSingletonVersionCheckFallback("default", "@descomplica/microfrontend-core", [7,1,4,2,,"beta",2], () => (() => (__webpack_require__(5208))))),
	7082: () => (loadSingletonFallback("default", "react", () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(2791))))))),
	7099: () => (loadStrictVersionCheckFallback("default", "react-data-table-component", [1,7,5,3], () => (Promise.all([__webpack_require__.e(513), __webpack_require__.e(6)]).then(() => (() => (__webpack_require__(3513))))))),
	7426: () => (loadStrictVersionCheckFallback("default", "@descomplica/design-system-react", [1,1,0,14], () => (Promise.all([__webpack_require__.e(22), __webpack_require__.e(950)]).then(() => (() => (__webpack_require__(3022))))))),
	7165: () => (loadStrictVersionCheckFallback("default", "web-vitals", [1,1,0,1], () => (__webpack_require__.e(787).then(() => (() => (__webpack_require__(787))))))),
	8722: () => (loadStrictVersionCheckFallback("default", "@descomplica/caching-browser", [0,0,0,1], () => (() => (__webpack_require__(2962))))),
	6785: () => (loadStrictVersionCheckFallback("default", "tsyringe", [0,4,7,0], () => (() => (__webpack_require__(2389))))),
	6737: () => (loadStrictVersionCheckFallback("default", "@descomplica/settings-browser", [0,1,0,0], () => (() => (__webpack_require__(5013))))),
	4016: () => (loadStrictVersionCheckFallback("default", "axios", [0,0,24,0], () => (() => (__webpack_require__(4569))))),
	3122: () => (loadStrictVersionCheckFallback("default", "graphql-request", [0,5,2,0], () => (() => (__webpack_require__(4708))))),
	5637: () => (loadStrictVersionCheckFallback("default", "graphql", [,[1,16],[-1,16],1,[0,14],2], () => (() => (__webpack_require__(199)))))
};
var initialConsumes = [8722,6785,6737,4016,3122,5637];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"6": [
		2232,
		3595
	],
	"111": [
		5544,
		1371
	],
	"113": [
		2113
	],
	"116": [
		6116
	],
	"165": [
		7165
	],
	"416": [
		8416
	],
	"556": [
		4556
	],
	"649": [
		1649
	],
	"686": [
		915
	],
	"716": [
		5686,
		7796,
		8698,
		9705
	],
	"756": [
		756
	],
	"775": [
		9883,
		19
	],
	"827": [
		7827
	],
	"921": [
		117,
		128,
		150,
		172,
		1667,
		1919,
		1936,
		2488,
		3390,
		3544,
		3839,
		3854,
		4479,
		5243,
		5814,
		6129,
		6218,
		6759,
		6804,
		7082,
		7099,
		7426
	],
	"950": [
		2950
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}